import { bumpVisibilityEpoch } from '../engine/engine.js';

function setSubtreeVisible(node, v) {
  if (cascade(node, v)) {
    bumpVisibilityEpoch();
  }
}
function cascade(node, v) {
  let changed = node.visible !== v;
  node.visible = v;
  const kids = node.children;
  for (let i = 0; i < kids.length; i++) {
    if (cascade(kids[i], v)) {
      changed = true;
    }
  }
  return changed;
}

export { setSubtreeVisible };
//# sourceMappingURL=visibility.js.map
